import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { StateService, TransitionService } from '@uirouter/angular';

/**
 * Site admin homepage host. The tab bar (site-admin-homepage-header) offers an "Options" settings
 * tab plus the wiki View/Edit/Versions tabs. Options renders the site settings panel; the wiki tabs
 * render the shared, self-contained <wiki-container> (with its own tab bar hidden — the host owns
 * the bar so it can include the non-wiki Options tab). The homepage wiki is site-scoped
 * (section 'admin', refId 0), which the container fetches itself.
 */
@Component({
    selector: 'site-admin-homepage',
    template: `
        <site-admin-homepage-header [setting]="setting"></site-admin-homepage-header>

        <site-admin-homepage-options *ngIf="activeTab === 'options'"
            [setting]="setting"></site-admin-homepage-options>

        <wiki-container *ngIf="activeTab !== 'options'"
            [showTabs]="false"
            [baseState]="'home.admin.homepage'"
            [tabs]="['view','edit','versions']"
            [project]="null"
            [projectMenu]="null"
            [pagename]="'FrontPage'"
            [section]="'admin'"
            [refId]="0"
            [showSidebar]="false"
            [showTags]="false"
            [showAttachments]="false"
            [manageChrome]="false"
            [controls]="{}"></wiki-container>
    `
})
export class SiteAdminHomepageComponent implements OnInit, OnDestroy {
    @Input() setting: any = null;

    activeTab: string = 'options';
    private deregisterSuccess: Function | null = null;

    constructor(
        private stateService: StateService,
        private $transitions: TransitionService,
    ) {}

    ngOnInit(): void {
        this.setActiveFromState(this.stateService.current && this.stateService.current.name);
        this.deregisterSuccess = this.$transitions.onSuccess({}, (transition) => {
            this.setActiveFromState(transition.to().name);
        });
    }

    ngOnDestroy(): void {
        if (this.deregisterSuccess) { this.deregisterSuccess(); this.deregisterSuccess = null; }
    }

    private setActiveFromState(stateName: string | undefined): void {
        const prefix = 'home.admin.homepage.';
        this.activeTab = (stateName && stateName.startsWith(prefix))
            ? stateName.slice(prefix.length).split('.')[0]
            : 'options';
    }
}
